module.exports = "<div></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/load-script/load-script.html
// module id = 273
// module chunks = 0